var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_123_95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.3641 45.5443L54.7026 1.88611C52.1899 -0.628705 48.1116 -0.628705 45.5957 1.88611L36.5294 10.9524L48.0304 22.4534C50.7032 21.5504 53.7677 22.1561 55.8985 24.2869C58.0392 26.4308 58.6405 29.5217 57.7155 32.2033L68.7996 43.2874C71.4812 42.3635 74.5753 42.9615 76.7171 45.1066C79.7103 48.0987 79.7103 52.9484 76.7171 55.9427C73.7228 58.937 68.8731 58.937 65.8777 55.9427C63.6262 53.689 63.0699 50.382 64.2099 47.6082L53.8731 37.2713L53.872 64.4735C54.6016 64.8356 55.2907 65.3173 55.8985 65.9229C58.8917 68.915 58.8917 73.7647 55.8985 76.7612C52.9042 79.7544 48.0524 79.7544 45.0624 76.7612C42.0692 73.7647 42.0692 68.915 45.0624 65.9229C45.802 65.1845 46.6578 64.626 47.5707 64.2508V36.7951C46.6578 36.4221 45.8031 35.8669 45.0624 35.123C42.7945 32.8583 42.2492 29.5305 43.4111 26.7457L32.0747 15.4071L2.13718 45.3425C-0.378735 47.8595 -0.378735 51.9378 2.13718 54.4526L45.7987 98.112C48.3124 100.627 52.3896 100.627 54.9067 98.112L98.3641 54.6556C100.879 52.1397 100.879 48.0592 98.3641 45.5443Z",
    fill: "#DE4C36"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_123_95"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(0.25)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGit);
export default __webpack_public_path__ + "static/media/git.80b3057bcef7d109dd9d565f68a6f985.svg";
export { ForwardRef as ReactComponent };